import React from 'react';
import { Loader2, XCircle } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';

/**
 * Reject-an-adjustment-request confirmation dialog.
 */
const RejectAdjustmentDialog = ({
  open,
  onOpenChange,
  rejectionReason,
  setRejectionReason,
  processing,
  onReject,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="text-red-600">Reject Adjustment</DialogTitle>
        <DialogDescription>
          Provide a reason for rejecting this adjustment request. The client will be notified.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-2">
        <div>
          <Label>Rejection Reason *</Label>
          <Textarea
            placeholder="Explain why this adjustment is being rejected..."
            rows={3}
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            className="mt-1"
          />
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => {
              onOpenChange(false);
              setRejectionReason('');
            }}
          >
            Cancel
          </Button>
          <Button
            className="flex-1"
            variant="destructive"
            onClick={onReject}
            disabled={processing}
          >
            {processing
              ? <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              : <XCircle className="h-4 w-4 mr-2" />}
            {processing ? 'Rejecting...' : 'Reject Adjustment'}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default RejectAdjustmentDialog;
